import { GetMachine,MachineError,MachineErrorList} from '@/api/machine'
export default {
  state: {
    machine: []
  },
  getters: {
    machine: state => state.machine
  },
  actions: {
    GetMachine ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachine(payload).then(res => {
          commit('SET_MACHINE', res.data)
          resolve(res.data)
        })
      })
    },
    MachineError({commit},payload){
      return new Promise(resolve=>{
        MachineError(payload).then(res=>{
          resolve(res.data)
        })
      })
    },
    MachineErrorList({commit},payload){
      return new Promise(resolve=>{
        MachineErrorList(payload).then(res=>{
          resolve(res.data)
        })
      })
    },
    
  },
  mutations: {
    SET_MACHINE (state, payload) {
      payload.machine.map(item=>{
        item.machine_status = 0
      })
      state.machine = payload.machine
    }
  }
}
